import {Rating} from "@mui/material";
import React from "react";

function RatingLink({url}) {
    const handleRatingClick = () => {
        window.open(url, "_blank");
    };

    return (
        <a href={url} target={"_blank"}>
            <Rating defaultValue={5}/>
        </a>
    );
}

export default RatingLink;
